// extracted by mini-css-extract-plugin
export default {"imageWrapper":"eK-z","twoColumnImage":"fK-z"};